import { render, staticRenderFns } from "./plainMobile.vue?vue&type=template&id=72bd1830&scoped=true&"
import script from "./plainMobile.vue?vue&type=script&lang=js&"
export * from "./plainMobile.vue?vue&type=script&lang=js&"
import style0 from "./plainMobile.vue?vue&type=style&index=0&id=72bd1830&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd1830",
  null
  
)

export default component.exports